export const coreVersion = "3.0.32";
export const VxeCore = {
    coreVersion,
    uiVersion: '',
    tableVersion: ''
};
